
import { Vue, Component } from 'vue-property-decorator';
import { Toast } from 'vant';
import People from './People.vue';

Vue.use(Toast);
@Component({
  components: {
    People,
  },
})
export default class List extends Vue {
  activity: number = 0;
}
